import { createContext, useContext, useState } from "react";

/**
 * Very small UI-overlay context so unrelated components can coordinate
 * visibility without pulling in a global state manager.
 *
 *  - `menuOpen`            : mobile hamburger menu is open (Header publishes)
 *  - `primaryCtaVisible`   : the product page's primary CTA is on-screen
 *                            (ProductDetailPage publishes via IntersectionObserver)
 *
 * Consumers such as FloatingWhatsApp use these flags to hide themselves
 * when they would visually collide with existing controls.
 */
const UICtx = createContext({
  menuOpen: false,
  setMenuOpen: () => {},
  primaryCtaVisible: false,
  setPrimaryCtaVisible: () => {},
});

export function UIOverlayProvider({ children }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [primaryCtaVisible, setPrimaryCtaVisible] = useState(false);
  return (
    <UICtx.Provider value={{ menuOpen, setMenuOpen, primaryCtaVisible, setPrimaryCtaVisible }}>
      {children}
    </UICtx.Provider>
  );
}

export const useUIOverlay = () => useContext(UICtx);
